import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

interface FeatureCardProps {
  icon: string;
  title: string;
  desc: string;
  delay: number;
}

function FeatureCard({ icon, title, desc, delay }: FeatureCardProps) {
  const { elementRef } = useScrollAnimation({ delay });
  return (
    <div
      ref={elementRef}
      className="animate-fade-up rounded-xl p-6 sm:p-8 text-center shadow-sm hover:shadow-md transition-shadow duration-300"
      style={{ background: '#fafafa', border: '1px solid #f0e0b0' }}
    >
      <div className="w-14 h-14 flex items-center justify-center rounded-full mx-auto mb-5"
        style={{ background: 'linear-gradient(135deg, #B8860B, #F5D76E)' }}>
        <i className={`${icon} text-2xl`} style={{ color: '#000000' }}></i>
      </div>
      <h3 className="text-xl font-bold mb-3" style={{ color: '#000000' }}>{title}</h3>
      <p className="text-sm leading-relaxed" style={{ color: '#666666' }}>{desc}</p>
    </div>
  );
}

export default function AnnualReview() {
  const { elementRef: headerRef } = useScrollAnimation();

  const features = [
    { icon: 'ri-focus-3-line', title: 'Clarity', desc: 'Close the year with a clear picture of where you stand and what truly matters.' },
    { icon: 'ri-compass-3-line', title: 'Direction', desc: 'Design your next chapter with purpose-driven goals and an actionable roadmap.' },
    { icon: 'ri-fire-line', title: 'Momentum', desc: 'Enter the new year energised, focused, and ready to build your legacy.' },
  ];

  return (
    <section className="py-20 sm:py-24" style={{ background: '#ffffff' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={headerRef} className="animate-fade-up text-center mb-12 sm:mb-16">
          <p className="text-sm font-bold tracking-[0.3em] uppercase mb-3" style={{ color: '#C8102E' }}>
            Featured Program
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mb-4" style={{ color: '#000000' }}>
            Legacy Annual Review
          </h2>
          <div className="w-16 h-1 mx-auto mb-6 rounded-full" style={{ background: 'linear-gradient(90deg, #B8860B, #F5D76E)' }} />
          <p className="text-base sm:text-lg leading-relaxed max-w-2xl mx-auto" style={{ color: '#555555' }}>
            A guided reset to close the year with clarity and design the next chapter with intention.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8">
          {features.map((f, i) => (
            <FeatureCard key={i} icon={f.icon} title={f.title} desc={f.desc} delay={i * 100} />
          ))}
        </div>
      </div>
    </section>
  );
}
